import React, {memo} from 'react';
import {Container, AvatarImage, UserStatus, ContentText, NickName, UnReadBadge} from "./user-item.styles";
import {GREEN_COLOR, RED_COLOR} from "../../constants/colors";
import Placeholder from "../../assets/Images/profile-placeholder.png";

const UserItem = ({imageSource, userStatus, userName, lastMessage, clickHandler, active, classes = '', unreadCount = 0}) => {
    return (
        <Container className={['d-flex align-items-center justify-content-between', classes].join(' ')}
                   active={active}
                   onClick={clickHandler ? clickHandler : () => {}}>
            <div className='d-flex align-items-center'>
                <div className='position-relative'>
                    <AvatarImage>
                        <img src={imageSource} alt='avatar' className='w-100 h-100' onError={(e) => e.target.src=Placeholder}/>
                    </AvatarImage>
                    <UserStatus style={{backgroundColor: userStatus === 'online' ? GREEN_COLOR : RED_COLOR}}/>
                </div>

                <div className='ms-3'>
                    <NickName active={active} className='content-overflow mb-1'>{userName}</NickName>
                    <div>
                        <ContentText active={active} className='mb-0 content-overflow'>{lastMessage}</ContentText>
                    </div>
                </div>
            </div>
            {
                unreadCount !== 0 &&
                <UnReadBadge className='d-flex align-items-center justify-content-center'>
                    <span>{unreadCount}</span>
                </UnReadBadge>
            }
        </Container>
    );
};

export default memo(UserItem);
